/* eslint-disable security/detect-non-literal-fs-filename */
import React, {  useContext, useState, useCallback, useEffect } from 'react';
import { Loader, ModalBody, ModalFooter, ModalHeader, ModalNext, useModal } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { Button } from '@jutro/legacy/components';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import metadata from './PrintDocumentConfirmationPopup.metadata.json5';
import styles from './PrintDocumentConfirmationPopup.module.scss';
import messages from '../QuotePage.messages';

function PrintDocumentConfirmationPopup(props) {
    const {
        submissionVM, 
        setIsPrinting,
        isOpen,
        onResolve,
        onAfterClose,
        docPath,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        QuoteStatus
    } = props;

    const { showConfirm} = useModal();
    
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, /* setIsLoading */] = useState(false);

     const translator = useTranslator();

     useEffect(() => {
        setIsPrinting(true);
     },[setIsPrinting])
   
    const ACTION_MSG = {
        cancelQuoteAction: {
            title: translator(messages.cancelQuote),
            message: translator(messages.cancelMessage),
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.cancelMessageYesButton),
            cancelButtonText: translator(messages.cancelMessageButton),
        }
    };

    const messageCancelAction = ACTION_MSG.cancelQuoteAction;
    const handleGotoDocument = useCallback(() =>{

        showConfirm(messageCancelAction).then(result => {
            if (result === 'confirm') {
                setIsPrinting(false);
                window.open(docPath, '_self')
            }

            if(result === 'cancel'){
                setIsPrinting(false);
            }
        });

        setIsPrinting(false);
        onResolve();
    }, [docPath, messageCancelAction, onResolve, setIsPrinting, showConfirm])

    const handleContinue = useCallback(() => {
        setIsPrinting(false);
        onResolve();
    }, [onResolve, setIsPrinting]);


    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        printDocumentBodyId: {
            content: translator(messages.documentMessage)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext isOpen={isOpen} onAfterClose={onAfterClose} >
            <ModalHeader title="" />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={submissionVM}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleGotoDocument} type="outlined"> {translator(messages.documentConfirmButton)} </Button>
                <Button onClick={handleContinue}>{translator(messages.documentContinueButton)}</Button>
            </ModalFooter>
        </ModalNext>
    )
}

PrintDocumentConfirmationPopup.propTypes = {
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func
};

PrintDocumentConfirmationPopup.defaultProps = {
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop,
    onAfterClose: _.noop
};

export default PrintDocumentConfirmationPopup;